import type { DeepRequired } from '../fixtures.types'

// benefit_type is left out: the requirement fragments don't select it and PrivateMedicalInsuranceInput doesn't declare it
const privateMedicalInsurance: DeepRequired<Omit<PrivateMedicalInsurance, 'benefit_type'>> = {
  __typename: 'PrivateMedicalInsurance',
  id: 'TEST_ID',
  client_ids: [],
  existing_policy: null,
  cover_reason: null,
  underwriting_level: null,
  hospital_list: null,
  outpatient_full_cover: null,
  outpatient_cover: null,
  outpatient_cover_details: null,
  cancer_cover: null,
  dental: null,
  mental_health: null,
  optical: null,
  physiotherapy: null,
  private_gp_cover: null,
  six_week_option: null,
  therapies: null,
  travel_international: null,
  full_diagnostics: null,
}

export default privateMedicalInsurance
